import { render, staticRenderFns } from "./AllCopyrightSubmissions.vue?vue&type=template&id=031ff0ba&scoped=true&"
import script from "./AllCopyrightSubmissions.vue?vue&type=script&lang=js&"
export * from "./AllCopyrightSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./AllCopyrightSubmissions.vue?vue&type=style&index=0&id=031ff0ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031ff0ba",
  null
  
)

export default component.exports